import { SureMailIcon } from '@assets/icons';
import { Button } from '@bsf/force-ui';
import { XIcon } from 'lucide-react';
import { __ } from '@wordpress/i18n';

// Admin notice styles
import '../style.css';

const Notice = () => {
	const handleDismiss = () => {
		// Remove it from the dom
		const notice = document.getElementById( 'suremails-admin-notice' );
		if ( notice ) {
			notice.remove();
		}
	};

	const dashboardUrl = window?.suremailsNotice?.dashboardUrl ?? '';

	return (
		<div className="flex items-center justify-between bg-background-primary p-3 rounded-tr-lg rounded-br-lg overflow-hidden">
			<div className="flex items-center justify-start gap-2">
				<SureMailIcon className="shrink-0 size-7 mx-4" />
				<p className="p-0">
					{ __(
						"Your website's emails may not be delivering! Create a connection with an SMTP service to ensure reliable email delivery",
						'suremails'
					) }
					<Button
						variant="link"
						size="md"
						className="p-0 hover:no-underline focus:[box-shadow:none] [box-shadow:none]"
						onClick={ () =>
							window.open(
								dashboardUrl,
								'_self',
								'noopener,noreferrer'
							)
						}
					>
						{ __( 'Configure SureMail', 'suremails' ) }
					</Button>
				</p>
			</div>
			<Button
				className="p-0.5 before:hidden"
				size="sm"
				variant="ghost"
				icon={ <XIcon /> }
				onClick={ handleDismiss }
			/>
		</div>
	);
};

export default Notice;
